<template>
  <div class="customForms">
    <v-container>

      <v-row>
        <v-col class="text-center">
          <h1 class="GTAmerica">{{form.formName}}</h1>
        </v-col>
      </v-row>

      <template v-for="(category, c) in form.MaterialCategories">
        <div :key="'category-' + c">
          <v-row>
            <v-col>
              <div v-html="category.name"></div>
            </v-col>
          </v-row>
          <v-row>
            <template v-for="(material, m) in materials">
              <template v-if="material.category._id == category._id">
                <v-col cols="auto" :key="'material-' + m">
                  <template v-if="selectedMaterials.includes(material._id)">
                    <div
                      class="text-center pointer"
                      style="width: 150px; position: relative"
                      @click="removeItem(material._id)"
                    >
                      <div
                        style="
                          position: absolute;
                          top: -10px;
                          right: 50px;
                          z-index: 2;
                        "
                      >
                      <v-avatar color="black" size="16" class="py-0 my-0">
                        <v-icon size="12" color="white"> mdi-check </v-icon>
                      </v-avatar>
                      </div>
                      <v-avatar class="d-block mx-auto">
                        <v-img
                          :src="
                            'https://artlesscms.actstudio.xyz/' +
                            material.cover.path
                          "
                        ></v-img>
                      </v-avatar>
                      {{ material.name }}
                    </div>
                  </template>
                  <template v-else>
                    <div
                      class="text-center pointer"
                      style="width: 150px"
                      @click="selectedMaterials.push(material._id)"
                    >
                      <v-avatar class="d-block mx-auto">
                        <v-img
                          :src="
                            'https://artlesscms.actstudio.xyz/' +
                            material.cover.path
                          "
                        ></v-img>
                      </v-avatar>
                      {{ material.name }}
                    </div>
                  </template>
                </v-col>
              </template>
            </template>
          </v-row>
        </div>
      </template>

      <v-row>
        <v-col>
          <v-btn
            dark
            color="black"
            tile
            :ripple="false"
            elevation="0"
            block
            @click="dialog = true"
            class="btn-request"
          >
            <span class="white--text"> swatch </span>
            <span class="white--text bold"> request </span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialog" scrollable>
      <v-card>
        <v-card-title>
            <span class="d-block bold">SWATCH REQUEST FORM</span>
            <v-spacer></v-spacer>
            <v-icon @click="dialog = false;">mdi-close</v-icon>
        </v-card-title>
        
        <v-card-text style="height: calc(100vh - 100px)">

            <v-row align="start">
              <template v-for="(material, m) in selectedMaterials">
                <v-col :key="'sadkn'+m" cols="auto">
                  <div class="text-center d-inline-block" style="width: 150px">
                    <v-avatar class="d-block mx-auto">
                      <v-img :src="'https://artlesscms.actstudio.xyz/' + getMaterial(material).cover.path"></v-img>
                    </v-avatar>
                    {{getMaterial(material).name}}
                  </div>
                </v-col>
              </template>
            </v-row>

            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
            >
                <v-row>
                    <v-col>
                        <v-text-field label="Email Address" color="grey" v-model="formData.Email"></v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field label="City" color="grey" v-model="formData.City"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field label="Project or client reference" color="grey" v-model="formData.Project"></v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field label="State" color="grey" v-model="formData.State"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field label="Name" color="grey" v-model="formData.Name"></v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field label="Zip code" color="grey" v-model="formData.ZipCode"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field label="Street Address" color="grey" v-model="formData.Address"></v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field label="Telephone number" color="grey" v-model="formData.Phone"></v-text-field>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-0">
          <v-btn color="black" dark tile @click="validate()" block>
            Request
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" color="#221f1f">
      <span class="white--text text-center">
        THANK <span class="bold white--text">YOU!</span>
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        MaterialCategories: [],
      },
      flag: false,
      materials: [],
      selectedMaterials: [],
      dialog: false,
      valid: true,
      requiredRules: [
        v => !!v || '* Required'
      ],
      snackbar: false,
      formData: {
        Email: '',
        City: '',
        Project: '',
        Name: '',
        ZipCode: '',
        Address: '',
        Phone: '',
        // Item1: null,
        // Item2: null,
        // Item3: null,
        // Item4: null,
        // Item5: null,
        // Item6: null,
        // Item7: null,
        // Item8: null,
        // Item9: null,
        // Item10: null,
        // Item11: null,
        // Item12: null,
        // Item13: null,
        // Item14: null,
        // Item15: null,
        // Item16: null,
        // Item17: null,
        // Item18: null,
        // Item19: null,
        // Item20: null,
        // Item21: null,
        // Item22: null,
        // Item23: null,
        // Item24: null,
        // Item25: null
      }
    };
  },
  beforeMount: function () {
    var aux = this;
    //MaterialsCustomForms

    fetch(
      "https://www.artlesscms.actstudio.xyz/api/collections/get/MaterialsCustomForms",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          filter: {
            url: this.$route.params.url
          },
          fields: {},
          populate: 2, // resolve linked collection items
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (this.form = res.entries[0]))
      .then((res) => (this.flag = true))
      .then(() => this.fillMaterials());
  },
  computed: {
    categoriesSelection: function () {
      let mats = [];
      let categories = [];

      for (
        let index = 0;
        index < this.form.MaterialCategories.length;
        index++
      ) {
        const category = this.form.MaterialCategories[index];

        let object = {
          category: category._id,
        };

        categories.push(object);
      }

      return categories;
    },
  },
  methods: {
    fillMaterials: function () {
      var aux = this;
      fetch(
        "https://www.artlesscms.actstudio.xyz/api/collections/get/Materials",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            filter: {
              $or: this.categoriesSelection,
            },
            fields: {},
            sort: {name:1},
            populate: 2, // resolve linked collection items
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => (this.materials = res.entries));
    },
    removeItem: function (_id) {
      var elements = [];
      for (let index = 0; index < this.selectedMaterials.length; index++) {
        const element = this.selectedMaterials[index];

        if (element != _id) {
          elements.push(element);
        }
      }

      console.log(elements);
      this.selectedMaterials = elements;
    },
    validate () {
      this.$refs.form.validate()

      var pickedMaterials = {};

      for (let index = 0; index < this.selectedMaterials.length; index++) {
        const element = this.selectedMaterials[index];

        if(index == 0){
          this.formData.Swatchatch1 = this.getMaterial(element).name
        }

        if(index == 1){
          this.formData.Swatchatch2 = this.getMaterial(element).name
        }

        if(index == 2){
          this.formData.Swatchatch3 = this.getMaterial(element).name
        }

        if(index == 3){
          this.formData.Swatchatch4 = this.getMaterial(element).name
        }

        if(index == 4){
          this.formData.Swatchatch5 = this.getMaterial(element).name
        }

        if(index == 5){
          this.formData.Swatchatch6 = this.getMaterial(element).name
        }

        if(index == 6){
          this.formData.Swatchatch7 = this.getMaterial(element).name
        }

        if(index == 7){
          this.formData.Swatchatch8 = this.getMaterial(element).name
        }

        if(index == 8){
          this.formData.Swatchatch9 = this.getMaterial(element).name
        }

        if(index == 9){
          this.formData.Swatchatch10 = this.getMaterial(element).name
        }

        if(index == 10){
          this.formData.Swatchatch11 = this.getMaterial(element).name
        }

        if(index == 11){
          this.formData.Swatchatch12 = this.getMaterial(element).name
        }

        if(index == 12){
          this.formData.Swatchatch13 = this.getMaterial(element).name
        }

        if(index == 13){
          this.formData.Swatchatch14 = this.getMaterial(element).name
        }

        if(index == 14){
          this.formData.Swatchatch15 = this.getMaterial(element).name
        }

        if(index == 15){
          this.formData.Swatchatch16 = this.getMaterial(element).name
        }

        if(index == 16){
          this.formData.Swatchatch17 = this.getMaterial(element).name
        }

        if(index == 17){
          this.formData.Swatchatch18 = this.getMaterial(element).name
        }

        if(index == 18){
          this.formData.Swatchatch19 = this.getMaterial(element).name
        }

        if(index == 19){
          this.formData.Swatchatch20 = this.getMaterial(element).name
        }

        if(index == 20){
          this.formData.Swatchatch21 = this.getMaterial(element).name
        }

        if(index == 21){
          this.formData.Swatchatch22 = this.getMaterial(element).name
        }

        if(index == 22){
          this.formData.Swatchatch23 = this.getMaterial(element).name
        }

        if(index == 23){
          this.formData.Swatchatch24 = this.getMaterial(element).name
        }

        if(index == 24){
          this.formData.Swatchatch25 = this.getMaterial(element).name
        }

      }

      console.log(this.formData)

      fetch('https://www.artlesscms.actstudio.xyz/api/forms/submit/InternalSwatches?token=cf00a9204acb3ab54e671ca7655e5f', {
          method: 'post',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
              form: this.formData
          })
      })
      .then(entry => entry.json())
      .then(entry => console.log(entry));

      this.snackbar = true;
      this.dialog = false;
      this.selectedMaterials = []
    },
    getMaterial: function(_id){
      let material = this.materials.filter(mat => mat._id == _id)
      return material[0]
    }
  },
};
</script>